import { PresentationContent, ChatMessage } from "../../../types";
import { AiRequestOptions, StreamCallbacks, ToolExecutionPolicy } from "../types";
import { getCurrentModel } from "../../../utils";
import { queryOpenAI } from "./openai";
import { queryAnthropic } from "./anthropic";
import { queryGemini } from "./gemini";

export async function queryOpenAIStreaming(
  presentationContent: PresentationContent,
  userQuery: string,
  callbacks: StreamCallbacks,
  slideImages?: string | string[],
  chatHistory?: ChatMessage[],
  toolPolicy?: ToolExecutionPolicy,
  options: AiRequestOptions = {}
): Promise<void> {
  const model = getCurrentModel();

  const images = slideImages
    ? Array.isArray(slideImages)
      ? slideImages
      : [slideImages]
    : undefined;
  const hasPreludeUserMessages =
    options.preludeUserMessages?.some((message) => message.trim().length > 0) === true;

  if (model.provider !== "openai" && hasPreludeUserMessages) {
    callbacks.onError("PowerPoint Skills are not available with the selected AI provider.");
    return;
  }

  switch (model.provider) {
    case "anthropic":
      return queryAnthropic(
        presentationContent,
        userQuery,
        callbacks,
        model,
        images,
        chatHistory,
        toolPolicy,
        options
      );
    case "google":
      return queryGemini(
        presentationContent,
        userQuery,
        callbacks,
        model,
        images,
        chatHistory,
        toolPolicy,
        options
      );
    case "openai":
    default:
      return queryOpenAI(
        presentationContent,
        userQuery,
        callbacks,
        model,
        images,
        chatHistory,
        toolPolicy,
        options
      );
  }
}

export { queryOpenAI } from "./openai";
export { queryAnthropic } from "./anthropic";
export { queryGemini } from "./gemini";
